<template>
  <div class="wrapper">
    <parallax class="section "> </parallax>
    <div class="main">
      <div class="section section-contacts">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item">
              <b-breadcrumb id="inNav" style="background:transparent;">
                <b-breadcrumb-item
                  style="//styleName: Title;
font-family: Noto Serif JP;
font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: 28px;
letter-spacing: 0em;
text-align: left;
"
                  href="/"
                  >Home</b-breadcrumb-item
                >
                <b-breadcrumb-item
                  style="color: #c1a360 !important; //styleName: Title;
font-family: Noto Serif JP;
font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: 28px;
letter-spacing: 0em;
text-align: left;
"
                  active
                  >Locations</b-breadcrumb-item
                >
              </b-breadcrumb>
              <h2 class="title">Locations</h2>

              <div class="row row-cols-1 row-cols-md-3 g-4">
                <div class="col">
                  <div class="card h-100">
                    <img
                      src="https://mdbootstrap.com/img/new/standard/city/041.jpg"
                      class="card-img-top"
                      alt="..."
                    />
                    <!-- <div class="card-body">
        <h5 class="card-title">Card title</h5>
        <p class="card-text">
          This is a longer card with supporting text below as a natural lead-in to
          additional content. This content is a little bit longer.
        </p>
      </div> -->
                  </div>
                </div>
                <div class="col">
                  <div class="card h-100">
                    <img
                      src="https://mdbootstrap.com/img/new/standard/city/042.jpg"
                      class="card-img-top"
                      alt="..."
                    />
                    <!-- <div class="card-body">
        <h5 class="card-title">Card title</h5>
        <p class="card-text">This is a short card.</p>
      </div> -->
                  </div>
                </div>
                <div class="col">
                  <div class="card h-100">
                    <img
                      src="https://mdbootstrap.com/img/new/standard/city/043.jpg"
                      class="card-img-top"
                      alt="..."
                    />
                    <!-- <div class="card-body">
        <h5 class="card-title">Card title</h5>
        <p class="card-text">
          This is a longer card with supporting text below as a natural lead-in to
          additional content.
        </p>
      </div> -->
                  </div>
                </div>
                <div class="col">
                  <div class="card h-100">
                    <img
                      src="https://mdbootstrap.com/img/new/standard/city/044.jpg"
                      class="card-img-top"
                      alt="..."
                    />
                    <!-- <div class="card-body">
        <h5 class="card-title">Card title</h5>
        <p class="card-text">
          This is a longer card with supporting text below as a natural lead-in to
          additional content. This content is a little bit longer.
        </p>
      </div> -->
                  </div>
                </div>
                <div class="col-md"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "locations",
  bodyClass: "landing-page",
  props: {
    header: {
      type: String,
      default: require("@/assets/img/bg7.jpg")
    },
    teamImg1: {
      type: String,
      default: require("@/assets/img/faces/avatar.jpg")
    },
    teamImg2: {
      type: String,
      default: require("@/assets/img/faces/christian.jpg")
    },
    teamImg3: {
      type: String,
      default: require("@/assets/img/faces/kendall.jpg")
    }
  },
  data() {
    return {
      name: null,
      email: null,
      message: null
    };
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}

.md-outline input:focus {
  border-color: #c1a360 !important;
  box-shadow: inset 0 0 0 1px #c1a360 !important;
  border-bottom: 1px solid #c1a360 !important;
}

.md-outline label.active {
  color: #c1a360 !important;
}
.card {
  padding-top: 15px !important;
  border-style: none;
}
#inNav > li > a {
  color: black;
}

.Details {
  // font-family: Noto Sans JP !important;
  //styleName: H4;
  font-family: Noto Serif JP;
  font-size: 26px;
  font-style: normal;
  font-weight: 900;
  line-height: 40px;
  letter-spacing: 0em;
  text-align: left;

  color: #c1a360 !important;
}
.title {
  //styleName: Hero;
  font-family: Noto Serif JP !important;
  font-size: 65px !important;
  font-style: normal !important;
  font-weight: 700 !important;
  line-height: 96px !important;
  letter-spacing: 0em !important;
  text-align: left !important;
  color: black !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
</style>
